var _rect, _rect2, _rect3, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3600 2400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of Equatorial Guinea") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3600,
    height: 2400,
    fill: "#e32118"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3600,
    height: 1600,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3600,
    height: 800,
    fill: "#3e9a00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0V2400L900,1200z",
    fill: "#0073ce"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shield"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 4.8,
    d: "M1608,958.8H1991V1360C1991,1495 1815,1391 1800,1463C1774,1389 1609,1496 1609,1352C1609,1212 1608,958.8 1608,958.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#73452b",
    d: "M1827,1399C1827,1399 1822,1404 1813,1400C1804,1396 1803,1143 1803,1143C1823,1121 1839,1114 1839,1114C1839,1114 1851,1124 1851,1124C1806,1147 1810,1180 1814,1237C1815,1258 1815,1285 1820,1311C1827,1344 1841,1372 1842,1393C1843,1406 1827,1399 1827,1399z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#73452b",
    d: "M1796,1108H1814C1799,1253 1812,1339 1812,1381C1812,1395 1820,1400 1819,1400C1801,1420 1792,1399 1792,1399z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a36629",
    d: "M1768,1399C1751,1407 1749,1391 1750,1389C1787,1314 1803,1149 1769,1131C1769,1131 1771,1115 1771,1115C1784,1119 1796,1136 1796,1136C1801,1321 1796,1397 1793,1400C1775,1419 1768,1397 1767,1395"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1767,1396C1764,1380 1793,1339 1791,1296"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1816,1331C1825,1356 1829,1378 1827,1399"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009a3b",
    d: "M1855,1040C1861,1033 1861,1033 1872,1033C1874,1018 1899,1018 1901,1037C1921,1033 1925,1045 1917,1057C1936,1052 1953,1057 1948,1079C1982,1088 1969,1112 1954,1117C1952,1132 1938,1137 1919,1131C1895,1148 1881,1142 1870,1125C1843,1129 1841,1123 1829,1108C1808,1117 1804,1117 1786,1106C1785,1120 1780,1116 1771,1115C1772,1133 1765,1141 1749,1135C1761,1160 1730,1171 1715,1150C1701,1151 1700,1147 1693,1142C1687,1162 1665,1159 1661,1148C1633,1144 1636,1129 1659,1128C1661,1112 1675,1115 1684,1117C1685,1107 1691,1109 1696,1111C1693,1104 1695,1100 1704,1098C1691,1081 1699,1075 1712,1069C1705,1053 1717,1054 1726,1053C1725,1036 1730,1033 1748,1031C1746,1025 1749,1020 1759,1020C1753,1003 1761,999.1 1779,1002C1782,977.3 1835,989 1831,1023C1846,1025 1851,1028 1855,1040z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1748,1031C1752,1033 1757,1031 1758,1042C1766,1028 1776,1036 1776,1052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1831,1023C1827,1029 1812,1029 1814,1045C1809,1038 1799,1036 1795,1043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1855,1040C1855,1044 1854,1056 1850,1062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1917,1057C1918,1058 1903,1057 1896,1062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1954,1117C1950,1115 1942,1110 1936,1118C1936,1114 1936,1103 1925,1103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1919,1131C1919,1121 1917,1118 1915,1115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1886,1117C1878,1111 1870,1120 1870,1125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1828,1108C1828,1104 1825,1096 1832,1093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1714,1150C1716,1140 1723,1140 1722,1135C1721,1127 1712,1120 1701,1131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1722,1135C1728,1133 1734,1134 1736,1137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705,1098C1709,1094 1719,1095 1725,1098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1725,1074C1730,1074 1739,1072 1742,1081C1753,1064 1761,1066 1763,1070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1783,1068C1791,1065 1805,1073 1813,1087C1817,1076 1823,1078 1829,1077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1867,1087C1880,1081 1888,1093 1892,1098C1898,1090 1903,1090 1909,1090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1746,1111C1749,1106 1756,1105 1761,1108C1760,1099 1766,1095 1770,1097"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "stars",
    fill: "#ffd700",
    strokeWidth: 3.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1787,902.6 1765,903.6 1754,923.3 1742,904.5 1720,905.4 1730,885.6 1718,866.8 1741,865.8 1751,846.1 1763,864.9 1785,864 1775,883.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693,909.9 1671,915.3 1665,936.6 1649,920.6 1628,925.8 1634,904.5 1619,888.3 1640,883 1646,861.6 1662,877.6 1684,872.4 1677,893.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1602,928.6 1582,938.5 1581,960.7 1562,948.5 1542,958.3 1544,936.1 1525,923.8 1545,913.8 1547,891.6 1565,903.8 1585,894 1584,916.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1816,902.6 1838,903.6 1848,923.3 1860,904.5 1882,905.4 1872,885.6 1884,866.8 1862,865.8 1851,846.1 1839,864.9 1817,864 1827,883.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1910,909.9 1931,915.3 1937,936.6 1953,920.6 1974,925.8 1968,904.5 1984,888.3 1962,883 1956,861.6 1940,877.6 1919,872.4 1925,893.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2000,928.6 2020,938.5 2021,960.7 2040,948.5 2060,958.3 2059,936.1 2077,923.8 2057,913.8 2056,891.6 2037,903.8 2017,894 2019,916.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "motto"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: 3.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2027,1352 2052,1388 2075,1354 2059,1325z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1868,1457 1870,1493C1870,1493 1880,1493 1889,1490C1897,1487 1904,1481 1904,1481L1903,1462z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1734,1457 1732,1492C1732,1492 1723,1492 1714,1490C1706,1488 1699,1483 1699,1483L1689,1459z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1573,1352 1547,1388 1519,1342 1540,1320z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1698,1529C1698,1563 1904,1563 1904,1529V1481C1904,1506 1698,1501 1698,1481z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1514,1418C1532,1510 1698,1512 1698,1512C1698,1512 1698,1481 1698,1481C1694,1469 1701,1465 1728,1461C1739,1460 1734,1444 1734,1444C1734,1444 1662,1457 1611,1437C1542,1409 1532,1355 1532,1355C1532,1355 1527,1397 1514,1418z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2087,1418C2070,1510 1904,1512 1904,1512C1904,1512 1904,1481 1904,1481C1907,1469 1900,1465 1873,1461C1862,1460 1868,1444 1868,1444C1868,1444 1940,1457 1991,1437C2059,1409 2067,1355 2067,1355C2067,1355 2074,1397 2087,1418z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1527,1383C1481,1358 1517,1332 1521,1258C1528,1303 1579,1322 1573,1351C1552,1352 1542,1320 1532,1355C1532,1355 1527,1383 1527,1383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2074,1383C2120,1357 2082,1332 2078,1258C2071,1303 2021,1322 2027,1351C2047,1352 2057,1320 2067,1355C2067,1355 2074,1382 2074,1382z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1555,1417,5,4-11,12c-4.4031,4.8033-5.4674,7.9808-2.4093,10.905,3.7958,3.6295,6.4648,2.3682,10.409-1.905l12-13,4,4-11.989,13.989c-6.5084,7.5942-12.55,5.8563-17.618,1.1231-4.4158-4.1237-6.9466-10.102-0.4536-17.454l12.1-13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1575,1434,5,3-1,24,11-17,5,3-16,26-6-3,1-24-11,17-5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1584,1476,14-28,5,3-13,27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1606,1452-11.04,28.98,11.04,4.02c10.29,3.75,15.12-0.78,18.39-9.48,3.3-8.85,1.86-15.36-8.43-19.5l-9.96-4.02zm3.96,7.02c10.35,3.6,10.98,7.53,8.16,14.64-2.73,6.75-5.28,9.39-15.12,4.32l6.96-18.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1639,1463-18,27,6.96,2.04,4.02-7.02,12,3,1.02,7.02,6.96,0.96-6.96-31.98-6-1.02zm1.98,7.02,1.98,12-7.98-1.02,6-10.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1656.1,1465.6-1.0838,30.99,11.772,0.2309c10.941,0.2072,14.051-5.6204,14.318-14.91,0.2713-9.4506-3.2083-15.154-14.298-15.716l-10.708-0.5955zm6.0026,5.3771c10.964,0.044,12.838,3.5434,12.453,11.195-0.3657,7.273-1.9548,10.588-12.884,8.9686l0.4302-20.164z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1761,1509v31.98h7.02v-12s6,0.36,10.98-0.96c3.93-1.02,6.66-3.54,6.75-9.75,0.09-6.09-3.45-9.27-9.57-9.27h-15.2zm7.02,4.98,7.05,0.09c5.88,0,4.77,8.91,0.18,8.91h-7.23v-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1797,1509-13.02,31.98h7.02l3-7.98h13.02l3,7.98h6.96l-13-32h-7zm3,7.02,4.98,12h-9l4.02-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1817,1535,17-21-15,0,0-5,24,0,0,5-18,21,18,0,0,6-26,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1918,1473,6-1,3,18c1.0669,6.4013-1.8581,10.764-6.4144,12.445-5.1887,1.9138-11.806,0.1639-12.586-8.4449l5-1c1.1649,5.1523,3.2378,5.5985,5.6366,4.791,1.9038-0.6409,2.8885-3.6406,2.3634-6.791z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1928,1471.2,5.9209-1.1228,2.7393,14.979c1.1722,6.4098,3.1827,9.1354,7.3509,8.4077,5.1735-0.9034,5.741-3.8003,4.6402-9.5106l-3.6807-15.98,6.0571-0.9143,4.0192,16.623c2.3505,9.7215-2.7285,13.578-9.5455,14.851-5.9392,1.1094-12.253-0.3988-14.322-9.9873z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1959,1485,5-2c2.4529,4.4051,6.2799,4.1782,9.2549,2.8632,4.133-1.8269,4.6059-5.4402,2.5625-6.6628-2.9146-1.7438-9.8689,0.7328-13.615-0.6341-4.482-1.6353-6.4062-4.1562-6.1771-8.0319,0.2759-4.6664,4.3807-7.231,8.8456-8.6157,4.996-1.5495,9.9262-1.0022,13.129,5.0813l-6,2c-1.9531-3.2866-4.4662-3.1313-6.6964-2.0777-1.8668,0.882-4.784,2.5382-3.222,5.2058,1.2767,2.1802,8.6258,0.7645,12.498,0.9228,4.0034,0.1636,7.2389,2.8362,7.7805,6.6867,0.7551,5.3683-1.2338,8.2764-7.4407,10.697-7.6662,2.9898-14.582-0.3597-15.919-5.4346z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1986,1460-8,4-2-5,22-9,2,4-8,4,9,22-5,3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1999,1449,5-3,14,26-5,3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2033,1451,6-2c2.8215,5.9317-1.4152,16.715-11.775,16.493-15.164-0.3249-16.805-17.027-14.421-22.536,4.0051-9.252,15.224-9.0747,20.196-3.957l-5,4c-3.1698-4.0667-10.212-1.5041-10.688,2.2374-0.7756,6.1053,1.9122,11.788,7.371,14.483,4.6287,2.2846,11.761-3.4602,8.3165-8.7202z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2030,1430,5-4,18,24-5,4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2049,1415-4.98,4.02,10.98,30,4.98-4.98-3-6,9-8.04,6,3,5.04-3.96-28.02-14.04zm1.98,7.02,10.02,4.98-6,6-4.02-10.98z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGq);
export default __webpack_public_path__ + "static/media/gq.ad0ccfc211d4dd2eed87ba72518dd96b.svg";
export { ForwardRef as ReactComponent };